// WDN COPYRIGHT 2019 - Webdesign Nord ApS, CVR: 39048981
if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.CustomSortFromList === "undefined") {
  WDN.CustomSortFromList = (function() {
    // priv var
    var config, Clerk, Products, Page;

    // pub func
    var init;

    Products = {};

    config = {
      autorun: false,
      event_finish_name: "collection_products:updated",
      delay_until_timeout: 2500,
      not_found_action: "bury", // bury or remove
      item_identifier: "data-id"
    };

    Clerk = {
      base_url: "https://api.clerk.io/v2/recommendations/category/trending?",
      key: "1yHpjpXVWt0lSQYOP2qwipHpVVnvILF2"
    };

    Page = {
      element: {
        body: "body",
        wrap: ".collectionItems .grid",
        item: ".productItem--collection"
      }
    };

    Page.state = {
      loading_class: "State--is_loading",
      remove_loading: function() {
        $(Page.element.wrap).removeClass(Page.state.loading_class);
      },
      loading: function() {
        $(Page.element.wrap).addClass(Page.state.loading_class);
        // remove overlay again, if we somehow fail
        setTimeout(function() {
          Page.state.remove_loading();
        }, config.delay_until_timeout);
      },
      loaded: function() {
        Page.state.remove_loading();
        $(Page.element.body).trigger(config.event_finish_name);
      }
    };

    Clerk.endpoint = function(category, limit) {
      var obj, params;

      obj = {
        key: Clerk.key,
        category: category,
        limit: limit || 5000
      };

      params = Object.keys(obj)
        .map(function(key) {
          return key + "=" + obj[key];
        })
        .join("&");

      return Clerk.base_url + params;
    };

    // call api to return list of popular items sorted
    Clerk.load_list = function(url, cb) {
      // call clerk api to retrieve list of popular ids, sorted in an array
      $.getJSON(url, function(res) {
        Page.state.loading();
        cb(res.result);
      });
    };

    Products.find = function(id) {
      return $(Page.element.item + '[data-id="' + id + '"]');
    };

    Products.validateSort = function(notFound) {
      // run through proudcts to see if they are in place
      // if not, lets do not found action
      if (notFound.length > 0) {
        notFound.map(function(id) {
          var item = Products.find(id);

          switch (config.not_found_action) {
            case "bury":
              $(Page.element.wrap).append(item);
              break;
            case "remove":
              item.remove();
              break;
          }
        });
      }
    };

    // build and return a list of all products on page
    Products.onpage_list = function() {
      var _list = [];
      $(Page.element.item).each(function() {
        if ($(this).attr(config.item_identifier)) {
          _list.push($(this).attr(config.item_identifier));
        }
      });
      return _list;
    };

    // move non sorted items to bottom
    Products.clean_unfound = function(popular_list) {
      
      var _onpage_list = Products.onpage_list();

      // build list with items not found in API
      if (popular_list.length <= _onpage_list.length) {
        var notFound = _onpage_list.filter(function(item, index) {
          if (popular_list.indexOf(parseInt(item)) === -1) {
            return item;
          }
        });
        Products.validateSort(notFound);
      }

      Page.state.loaded();
    };

    // actual sorting function from input
    Products.sort = function(popular_list) {
      // sort items by data popular API
      popular_list.map(function(id, index) {
        // add our item to grid, after previously added products
        $(Page.element.wrap).append($(Page.element.item + '[data-id="' + id + '"]'));
      });

      Products.clean_unfound(popular_list);
    };

    // starter function
    init = function(limit) {
      var config = Clerk.endpoint(wdn_global_vars_collection.id, limit);
      var callback = Products.sort;
      Clerk.load_list(config, callback);
    };

    // lets get it poppin
    if (config.autorun) {
      init();
    }

    return {
      init: init
    };
  })();
}

// rebind here
$("body").on("collection_products:updated", function() {});
